import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from './cn';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    isCompact?: boolean;
  }
>(({ className, isCompact = false, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      {
        'h-[24px] w-[44px]': !isCompact,
        'h-[16px] w-[28px]': isCompact,
      },
      'peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-accent-quaternary focus-visible:ring-offset-2 focus-visible:ring-offset-bg-secondary disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-bg-accent-strong-primary data-[state=unchecked]:bg-border-primary',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        {
          'size-5 data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0':
            !isCompact,
          'size-3 data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0':
            isCompact,
        },
        'pointer-events-none block rounded-full bg-bg-primary shadow-lg ring-0 transition-transform ',
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
